"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.description = exports.note = exports.type = exports.icon = exports.time = exports.container = void 0;

var _util = require("../../../util");

const container = ({
  theme
}) => ({
  boxShadow: (0, _util.boxShadow)(theme, [0, -1, 0, 'ui1', true])
});

exports.container = container;

const time = () => ({
  minWidth: 28,
  maxWidth: 30
});

exports.time = time;

const icon = () => ({
  minWidth: 16
});

exports.icon = icon;

const type = () => ({
  minWidth: 128
});

exports.type = type;

const note = ({
  theme
}) => ({
  boxShadow: (0, _util.boxShadow)(theme, [2, 0, 0, 'ui4', true])
});

exports.note = note;

const description = () => ({
  flexGrow: 1
});

exports.description = description;
//# sourceMappingURL=Notification.style.js.map